var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-img"},[_c('img',{attrs:{"src":_vm.url,"alt":"","srcset":""}}),_c('div',{staticClass:"newsdesc-tit"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h2',[_vm._v(_vm._s(_vm.en))])])])}
var staticRenderFns = []

export { render, staticRenderFns }